// extracted by mini-css-extract-plugin
export default {"appUploadWrap":"AppUploadImg_appUploadWrap__FKTa5","appUploadIcon":"AppUploadImg_appUploadIcon__GQr4W"};